export class IconMap {
  constructor(public name: string, public path: string) {}
}
